// @flow
import { createContext } from 'react';

export const ConnectorsContext = createContext({});
